module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-photographer-2-b97c380b06e7bfb9709bf6824c7aaf2e.jpg";